export const items = [
  {
    image: {
      src: '/static/assets/images/blocks/adopte-1-doc.webp',
      alt: 'column_section_card_1_title',
      width: 160,
      height: 154,
    },
    title: 'column_section_card_1_title',
    text: 'column_section_card_1_text',
    link: 'ads_intro_link_href_adopt',
  },
  {
    image: {
      src: '/static/assets/images/blocks/2-jours-en-liberal.webp',
      alt: 'column_section_card_2_title',
      width: 160,
      height: 154,
    },
    title: 'column_section_card_2_title',
    text: 'column_section_card_2_text',
    link: 'ads_intro_link_href_liberal',
  },
  {
    image: {
      src: '/static/assets/images/blocks/job-de-carabin.webp',
      alt: 'column_section_card_3_title',
      width: 160,
      height: 154,
    },
    title: 'column_section_card_3_title',
    text: 'column_section_card_3_text',
    link: 'ads_intro_link_href_job',
  },
]
